/*
 * DEV-15069 — bundles anchor on the Pure Ultra collection.
 *
 * Tags the Replo bundles block with an id so /collections/pure-ultra#bundles scrolls to it, and
 * offsets the landing position by the sticky header so the heading is not hidden underneath it.
 *
 * Permanent and test-group agnostic. Purely additive: no visual change to the collection page.
 */

(() => {
  const script = document.currentScript;
  const selector = script?.dataset.target || '.custom-banner-02';
  const anchorId = script?.dataset.anchorId || 'bundles';

  /** The Replo section hydrates client-side, so the target may not exist at first paint. */
  const findTarget = () => document.querySelector(selector);

  const applyAnchor = (target) => {
    if (!target || target.id === anchorId) return false;
    if (document.getElementById(anchorId)) return false;

    target.id = anchorId;

    // Clear the sticky header. --header-height is published on <body> by theme.liquid.
    const headerHeight =
      getComputedStyle(document.body).getPropertyValue('--header-height').trim() || '80px';
    target.style.scrollMarginTop = `calc(${headerHeight} + 16px)`;

    return true;
  };

  /** A hash that was already in the URL on load resolved to nothing before the id existed. */
  const honourInitialHash = (target) => {
    if (window.location.hash !== `#${anchorId}`) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  };

  const init = () => {
    const target = findTarget();
    if (!applyAnchor(target)) return false;

    honourInitialHash(target);
    return true;
  };

  if (init()) return;

  // Replo had not rendered yet — watch for it, and give up rather than observe forever.
  const observer = new MutationObserver(() => {
    if (init()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 10000);
})();
